import { useTheme } from '@mui/material/styles';
import React from 'react';
import Modal from './common/Modal';
import ModalFooter from './common/ModalFooter';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

interface UnsavedChangesModalProps {
  open: boolean;
  onClose: () => void;
  onLeaveWithoutSaving: () => void;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  open,
  onClose,
  onLeaveWithoutSaving,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('common.unsavedChangesWarning')}
      size="xs"
      footer={
        <ModalFooter
          onCancel={onClose}
          onSubmit={onLeaveWithoutSaving}
          cancelText={t('buttons.no')}
          submitText={t('buttons.yes')}
          submitVariant="blue"
        />
      }
    >
      <Typography
        sx={{
          color: theme.palette.modal.title,
          fontSize: '16px',
          lineHeight: 1.5,
          mt: 4,
        }}
      >
        {t('common.unsavedChangesMessage')}
      </Typography>
    </Modal>
  );
};

export default UnsavedChangesModal;
